import styled from 'styled-components';

export const StyledAirfieldInformationWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  border-top: 1px solid #EFEFEF;
  border-bottom: 1px solid #EFEFEF;
  padding: 10px 0;

  .information-section-heading {
    width: 100%;
  }
`

export const StyledInformationColumn = styled.div`
  width: 100%;

  &:first-of-type {
    margin-bottom: 15px;
  }

  @media (min-width: 640px) {
    width: calc(50% - 15px);

    &::first-of-type {
      margin-right: 15px;
      margin-bottom: 0;
    }

    &:last-of-type {
      margin-left: 15px;
    }
  }

  ul {
    list-style: none;
    padding-left: 0;    

    li {
      color: #636463;
      font-family: "Open Sans";
      font-size: 14px;
      font-weight: 600 !important;
      letter-spacing: 0;
      line-height: 19px;
      margin-bottom: 10px;
    }
  }
`